  // Sticky header
  const className = 'bodyScrolled';
  const body = document.body;

  // Use the existing bodyScrollObserver div
  const headerScrollObserver = document.getElementById('bodyScrollObserver');

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (body.classList.contains(className)) {
          body.classList.remove(className);
        }
      } else {
        if (!body.classList.contains(className)) {
          body.classList.add(className);
        }
      }
    });
  });

  observer.observe(headerScrollObserver);